/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { MovementRoute, NewMovementRoute } from "./movementRoute";
import { User, getUserByAPIResponse } from "./user";

export interface MovementLog {
  id: number;
  at: string;
  departureId: number;
  departureCode: string;
  departureName: string;
  departureTime: Date;
  arrivalId: number;
  arrivalCode: string;
  arrivalName: string;
  arrivalTime: Date;
  totalFare: number;
  totalTime: number;
  totalDistanceKm: number;
  account: string;
  preparedRouteId: number;
  movementRoutes: MovementRoute[];
}

export interface NewMovementLog {
  at: string;
  departureId?: number;
  departureCode: string;
  departureName: string;
  departureTime?: Date;
  arrivalId?: number;
  arrivalCode: string;
  arrivalName: string;
  arrivalTime?: Date;
  totalFare: number;
  totalTime: number;
  totalDistanceKm: number;
  account: number;
  preparedRouteId?: number;
  modifiedBy: number;
  movementRoutes: NewMovementRoute[];
}

/* eslint-disable camelcase */
export interface MovementLogApproval {
  id: number;
  user_id: number;
  approval_month: string;
  approval_status: number;
  applicant_comment?: string;
  approver_user_id?: number;
  approver_comment?: string;
}
/* eslint-enable camelcase */

export interface MovementLogApprovalListItem {
  id: number;
  approvalMonth: Date;
  approvalStatus: string;
  approvalStatusName: string;
  applicantComment: string;
  approverComment: string;
  approverUser: User;
  summary: ExpensesSummary;
  user: User;
}

export interface Summary {
  totalFare: number;
  totalTime: number;
  totalDistance: number;
}

export interface ExpensesSummary {
  commutingExpenses: Summary;
  travelExpenses: Summary;
}

const getSummaryByAPIResponse = (summary: any) => ({
  totalFare: summary.total_fare,
  totalTime: summary.total_time,
  totalDistance: summary.total_distance,
});

const getExpensesSummaryByAPIResponse = (expensesSummary: any) => ({
  commutingExpenses: getSummaryByAPIResponse(
    expensesSummary.commuting_expenses
  ),
  travelExpenses: getSummaryByAPIResponse(expensesSummary.travel_expenses),
});

export const getMovementLogApprovalByAPIResponse = (
  movementLogApproval: any
): MovementLogApprovalListItem =>
  ({
    id: movementLogApproval.id,
    approvalMonth: new Date(movementLogApproval.approval_month),
    approvalStatus: movementLogApproval.approval_status,
    approvalStatusName: movementLogApproval.approval_status_name,
    applicantComment: movementLogApproval.applicant_comment,
    approverComment: movementLogApproval.approver_comment,
    approverUser: getUserByAPIResponse(movementLogApproval.approver_user),
    user: getUserByAPIResponse(movementLogApproval.user),
    summary: getExpensesSummaryByAPIResponse(movementLogApproval.summary),
  } as MovementLogApprovalListItem);

export const getMovementLogByAPIResponse = (movementLog: any): MovementLog =>
  ({
    id: movementLog.id,
    at: movementLog.at,
    departureId: movementLog.departure_id,
    departureCode: movementLog.departure_code,
    departureName: movementLog.departure_name,
    departureTime: movementLog.departure_time,
    arrivalId: movementLog.arrival_id,
    arrivalCode: movementLog.arrival_code,
    arrivalName: movementLog.arrival_name,
    arrivalTime: movementLog.arrival_time,
    totalFare: movementLog.total_fare,
    totalTime: movementLog.total_time,
    totalDistanceKm: movementLog.total_distance_km,
    account: movementLog.account,
    preparedRouteId: movementLog.prepared_route_id,
    movementRoutes: [],
  } as MovementLog);

/* eslint-enable */
